import type { Chapter, Comic } from "@/types/comic";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";

export function buildChapters(comic: Comic): Chapter[] {
  const total = comic.episodes;
  const list: Chapter[] = [];
  const base = new Date(comic.updatedAt).getTime();
  for (let i = 1; i <= total; i += 1) {
    const offsetDays = (total - i) * 2;
    const d = new Date(base - offsetDays * 24 * 60 * 60 * 1000);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    list.push({
      id: `${comic.id}-ch-${i}`,
      index: i,
      title: `第${i}话`,
      date: `${d.getFullYear()}-${month}-${day}`,
    });
  }
  return list;
}

export function getLatestChapter(comic: Comic): Chapter | undefined {
  return buildChapters(comic).slice(-1)[0];
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((item) => item.id === id);
}

export function getCategoryName(id: string): string {
  const found = categories.find((item) => item.id === id);
  return found ? found.name : "综合";
}

export function getCategoryById(id: string) {
  return categories.find((item) => item.id === id);
}

export function getRelatedComics(current: Comic, limit = 4): Comic[] {
  const scored = comics
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.category === current.category) score += 2;
      item.tags.forEach((tag) => {
        if (current.tags.includes(tag)) score += 1;
      });
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}